import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule, MatTooltipModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FcDataCardComponent } from './fc-data-card.component';

@NgModule({
  entryComponents: [
    FcDataCardComponent
  ],
  imports: [
    MatIconModule,
    MatTooltipModule,
    CommonModule,
    TranslateModule,
    NgxSkeletonLoaderModule
  ],
  declarations: [
    FcDataCardComponent
  ],
  exports: [
    FcDataCardComponent
  ]
})
export class FcDataCardModule {}
